import { render, staticRenderFns } from "./hospitalsEditModal.html?vue&type=template&id=fab6e70a&"
import script from "./hospitalsEditModal.vue?vue&type=script&lang=js&"
export * from "./hospitalsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports